import { getTranscriptsSummary } from '../../../services/dataQcSummaryService';
import { DATA_QC_TRANSCRIPTS_ITEMS_PER_PAGE } from '../../../constants';
import WithDataWrapper from '../../reusable/WithDataWrapper';
import { TranscriptsSummary } from '../../../interfaces/DataQcInterface';
import DataQcCardContentWithTable from '../DataQcCardContentWithTable';
import useSchools from '../../hooks/useSchools';
import useExternalSchoolCheck from '../hooks/useExternalSchoolCheck';
import ExternalSchoolMessage from '../ExternalSchoolMessage';

const columns = [
  { key: 'name', className: '' },
  { key: 'transcript_count', className: 'align-right' },
];
interface TranscriptsContentProps {
  data: TranscriptsSummary;
}

export function TranscriptsContent({ data }: TranscriptsContentProps) {
  const { dataQcSchool } = useSchools();
  const shouldShowExternalMessage = useExternalSchoolCheck();

  const { total_num_transcripts, schools } = data;

  if (shouldShowExternalMessage) {
    return <ExternalSchoolMessage message="We do not collect transcripts data for external schools." />;
  }

  return (
    <div data-testid="transcripts-content" className="transcripts-content">
      <div className="students-schools-count">
        <p data-testid="students-data">
          <span>{total_num_transcripts}</span> transcripts
        </p>
        {!dataQcSchool && (
          <p data-testid="schools-data">
            <span>{schools.length}</span> schools
          </p>
        )}
      </div>
      {!dataQcSchool && (
        <DataQcCardContentWithTable
          schools={schools}
          columns={columns}
          totalItems={data.schools.length}
          pageSize={DATA_QC_TRANSCRIPTS_ITEMS_PER_PAGE}
          itemsType="transcripts"
        />
      )}
    </div>
  );
}

const TranscriptsContentWithData = () => {
  const { dataQcSchool } = useSchools();
  const shouldShowExternalMessage = useExternalSchoolCheck();

  if (shouldShowExternalMessage) {
    return <ExternalSchoolMessage message="We do not collect transcripts data for external schools." />;
  }

  let fetchData = (eoaId: string, access_token: string) => getTranscriptsSummary(eoaId, access_token, dataQcSchool);

  return (
    <WithDataWrapper
      fetchData={fetchData}
      errorMessage="Error occurred while fetching transcripts summary data!"
      initialState={{
        schools: [{ id: '', name: '', transcript_count: 0 }],
        total_num_schools_with_transcripts: 0,
        total_num_transcripts: 0,
      }}
      options={{
        dependencies: [dataQcSchool],
        areDependenciesRequired: false,
      }}
    >
      {(data) => <TranscriptsContent data={data} />}
    </WithDataWrapper>
  );
};

export default TranscriptsContentWithData;
